<script>

export default {
  name: 'DetailStock',
  props:[
    "data",
    "openModal"
  ],
  components: {
  },
  data() {
    return {
        title:'',
        url:'/stock/details',
        submitted: false,
        odemeData:{},
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        columns:[
          {
            label: 'Ürün Adı',
            field: 'stock_group_name',
            sortable: false
          },
          { 
            label: 'Seri No',
            field: 'name',
            sortable: false
          },
          {
            label: 'IP',
            field: 'ip',
            sortable: false
          },
        ]
    }
  },
  watch:{
    openModal() {
        // eslint-disable-next-line no-console
        console.log(this.data)
        this.rows = []
        this.url = `/stock/details`
        this.updateParams({columnFilters:{'stock_group_id' : this.data.stock_group_id, 'user_id' :  this.data.user_id}})
        this.loadItems()
      }
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data.data,
                totalRecords: res.data.total,
                pageLength: res.data.last_page,
                currentPage: res.data.current_page,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    close(){
      this.$parent.$bvModal.hide('detail_stock')
    },


  },
};
</script>

<template>
  <b-modal id="detail_stock" size="xl" title="Stok Detayı"  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{ enabled: false }"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>